export default __webpack_public_path__ + "static/media/soda_img.e3bd0ef9.png";